import useProjectResultEntries from '../../hooks/portfolio/useProjectResultEntries'
import latestActivity from '../../helpers/dataHelpers/latestActivity'

/**
 * Outputkolom op het projectenoverzicht: hoeveel outputs heeft dit project
 * vastgelegd, en wanneer kwam de laatste binnen.
 *
 * 'Laatste' komt uit `latestActivity`, dat op de grootste tijdstempel kiest en
 * niet op een positie in de lijst — deze kolom pakte `results.length - 1` uit
 * een AFLOPEND gesorteerde lijst en toonde daarmee de OUDSTE output. Dat raakte
 * ook de kleur: `daysAgo` kwam uit datzelfde oude item, dus een project kleurde
 * voor altijd rood zodra het ooit iets ouds bevatte.
 *
 * @param {object} props
 * @param {string} props.projectId - `CompagnyID` van het project waarvan de outputs geteld worden
 */
const ProjectOutputProgress = ({projectId}) => {
    // Via een functie: een koepel mag de collectie van zijn projecten niet zelf lezen.
    const results = useProjectResultEntries(projectId || '').docs

    // 'Nog niet geladen' is een eigen toestand: de leesengine geeft '' tot de
    // eerste snapshot binnen is, en 'nul outputs' is dan een bewering aan de
    // lezer die niet waar hoeft te zijn.
    // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
    const loaded = Array.isArray(results)

    // Last result
    const last = latestActivity(results)

  return (
    <div>
        <p className={`project-progress ${!loaded ? 'project-progress--unknown' : results.length === 0 ? 'project-progress--alert' : 'project-progress--ok'}`}>
          Aantal: {loaded ? results.length : '–'}
        </p>
        {!loaded
          ? <p className="project-progress project-progress--unknown">Laatste: –</p>
          : last.atMs === null
            ? '-'
            : <p className={`project-progress ${last.daysAgo > 60 ? 'project-progress--alert' : 'project-progress--ok'}`}>Laatste: {last.label}</p>}
    </div>
  )
}

export default ProjectOutputProgress
